interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-shield-flash-line',
    title: '防封防失效',
    desc: '建立多级域名备份与实时监测系统，主域名一旦波动自动切换备用入口，确保91樱花最新网址永不失效。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速访问',
    desc: '全球CDN加速节点覆盖，多线路智能切换，无论你在哪里都能享受低延迟、高速度的动漫追番体验。',
  },
  {
    icon: 'ri-film-line',
    title: '海量片库',
    desc: '收录超过5000部动漫作品，从经典神作到当季新番，日漫国创一应俱全，满足各类漫迷的观看需求。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '支持PC、平板、手机全平台无缝访问，自适应布局确保在任何设备上都能获得舒适的浏览与观影体验。',
  },
  {
    icon: 'ri-lock-line',
    title: '安全无忧',
    desc: '全站HTTPS加密传输，无弹窗广告干扰，定期安全扫描，为你提供干净安全的动漫观看环境。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">为什么数百万漫迷选择91樱花作为动漫追番入口</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
              <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
          <div className="sm:col-span-2 lg:col-span-1 bg-primary-500 rounded-xl p-6 flex flex-col items-center justify-center text-center">
            <div className="w-12 h-12 bg-background-50/20 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-star-line text-xl text-background-50"></i>
            </div>
            <h3 className="font-heading text-base md:text-lg text-background-50 mb-2">永久免费</h3>
            <p className="text-sm text-background-50/80 leading-relaxed">所有功能完全免费开放使用，无需付费即可享受完整动漫追番体验。</p>
          </div>
        </div>
      </div>
    </section>
  );
}